// src/utils/blobDownload.js
//
// Hands a Blob to the browser as a file save. Needed because the documents
// download endpoint requires the bearer token, which a plain <a href> cannot
// carry — so the bytes come through apiFetch and are re-offered from an
// object URL. Kept out of the component so tests can mock the DOM side
// (jsdom has no URL.createObjectURL and no navigation).
export function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke on a later tick: revoking synchronously races the click in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
